
<mat-tab-group>
  @for (group of emojis; track $index) {
    <mat-tab>
      <ng-template mat-tab-label>
        <div [matTooltip]="group.name">{{ getEmoji(group.subGroups[0].emojis[0].code) }}</div>
      </ng-template>
      <ng-template matTabContent>
        <div class="emoji-grid">
          @for (subGroup of group.subGroups; track subGroup.name) {
            <div class="emoji-list">
              @for (emoji of subGroup.emojis; track $index) {
                <button matIconButton class="emoji-code" (click)="selectEmoji(emoji.code)" [matTooltip]="emoji.name" i18n-matTooltip>{{ getEmoji(emoji.code) }}</button>
              }
            </div>
          }
        </div>
      </ng-template>
    </mat-tab>
  }
  <mat-tab>
    <ng-template mat-tab-label>
      <div matTooltip="Search Emojis" i18n-matTooltip>🔍</div>
    </ng-template>
    <ng-template matTabContent>
      <div class="emoji-grid">
        <mat-form-field>
          <mat-label i18n>Search Emojis</mat-label>
          <input matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearchTermChange()" />
          @if (searchTerm) {
            <button matSuffix mat-icon-button  (click)="clearSearch()">
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
        <div class="emoji-list">
          @for (emoji of filteredEmojis; track $index) {
            <button matIconButton class="emoji-code" (click)="selectEmoji(emoji.code)" [matTooltip]="emoji.name" i18n-matTooltip>{{ getEmoji(emoji.code) }}</button>
          }
        </div>
        @if (searchTerm.length >= 3 && filteredEmojis.length === 0) {
          <p i18n>No emojis found.</p>
        }
      </div>
    </ng-template>
  </mat-tab>
</mat-tab-group>
